/* Protein Center — interazioni della homepage.
   Ogni sezione si inizializza da sola e si reinizializza quando il theme editor la ricarica. */
(function () {
  if (window.PCHome) return;
  document.documentElement.classList.add('pc-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('.pc-reveal, .pc-mask, [data-pc-reveal]');
    if (!('IntersectionObserver' in window) || reduced) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function heroParallax(root) {
    var img = root.querySelector('.pc-parallax');
    if (!img || reduced) return;
    var ticking = false;
    function update() {
      var r = root.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) img.style.setProperty('--py', (-r.top * 0.12).toFixed(1) + 'px');
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function tabs(root) {
    var list = root.querySelectorAll('[role="tab"]');
    list.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % list.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + list.length) % list.length;
        if (n !== null) { e.preventDefault(); select(n); list[n].focus(); }
      });
    });
    function select(i) {
      list.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        var p = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      rails(root);
    }
  }

  function rails(root) {
    root.querySelectorAll('.pc-panel:not([hidden])').forEach(function (panel) {
      var rail = panel.querySelector('.pc-rail');
      var bar = panel.querySelector('.pc-rail__progress i');
      if (!rail) return;
      function update() {
        if (!bar) return;
        var max = rail.scrollWidth - rail.clientWidth;
        var w = rail.clientWidth / rail.scrollWidth * 100;
        bar.style.width = w + '%';
        bar.style.left = (max > 0 ? rail.scrollLeft / max * (100 - w) : 0) + '%';
      }
      if (!rail.dataset.bound) {
        rail.dataset.bound = '1';
        rail.addEventListener('scroll', update, { passive: true });
        panel.querySelectorAll('.pc-rail__btn').forEach(function (b) {
          b.addEventListener('click', function () {
            rail.scrollBy({ left: rail.clientWidth * 0.8 * Number(b.dataset.dir), behavior: reduced ? 'auto' : 'smooth' });
          });
        });
      }
      update();
    });
  }

  function cats(root) {
    var float = root.querySelector('.pc-cats__float');
    if (!float || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var imgs = float.querySelectorAll('img');
    var x = 0, y = 0, cx = 0, cy = 0, raf = null;
    function loop() {
      cx += (x - cx) * 0.16; cy += (y - cy) * 0.16;
      float.style.left = cx + 'px'; float.style.top = cy + 'px';
      raf = Math.abs(x - cx) + Math.abs(y - cy) > 0.5 ? requestAnimationFrame(loop) : null;
    }
    root.querySelectorAll('.pc-cat a').forEach(function (a, i) {
      a.addEventListener('mouseenter', function (e) {
        if (!imgs[i] || !imgs[i].getAttribute('src')) return;
        imgs.forEach(function (im, j) { im.classList.toggle('is-on', i === j); });
        if (!float.classList.contains('is-on')) { cx = x = e.clientX; cy = y = e.clientY; }
        float.classList.add('is-on');
      });
      a.addEventListener('mouseleave', function () { float.classList.remove('is-on'); });
    });
    root.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      if (!raf) raf = requestAnimationFrame(loop);
    });
  }

  function manifesto(root) {
    var words = root.querySelectorAll('.pc-manifesto__text .w');
    if (!words.length || reduced) { words.forEach(function (w) { w.classList.add('on'); }); return; }
    var text = root.querySelector('.pc-manifesto__text');
    var ticking = false;
    function update() {
      var r = text.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * words.length);
      words.forEach(function (w, i) { w.classList.toggle('on', i < n); });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }


  var PLATES = {
    '25': { w: 28, h: 1, c: '#d43747' },
    '20': { w: 25, h: 1, c: '#2f6bff' },
    '15': { w: 22, h: 0.86, c: '#f5c400' },
    '10': { w: 18, h: 0.72, c: '#bbff00' },
    '5': { w: 13, h: 0.5, c: '#f3f3ee' },
    '2.5': { w: 10, h: 0.38, c: '#1a1a1a' }
  };
  var BAR_KG = 20;

  function barbell(root) {
    var el = root.querySelector('[data-pc-barbell]');
    if (!el) return;
    var rig = el.querySelector('[data-bb-rig]');
    var stage = el.querySelector('[data-bb-stage]');
    var sides = el.querySelectorAll('[data-bb-side]');
    var totalEl = el.querySelector('[data-bb-total]');
    var msgEl = el.querySelector('[data-bb-msg]');
    var cta = el.querySelector('[data-bb-cta]');
    var hint = msgEl.textContent;
    var max = Number(el.dataset.max) || 6;
    var msgs = [];
    try { msgs = JSON.parse(el.dataset.msgs || '[]'); } catch (e) {}
    var loaded = [];
    var shown = BAR_KG;
    var lastMsg = '';

    function total() {
      return BAR_KG + loaded.reduce(function (s, kg) { return s + Number(kg) * 2; }, 0);
    }

    function say(text) {
      if (text === lastMsg) return;
      lastMsg = text;
      msgEl.textContent = text;
      msgEl.classList.remove('is-pop'); void msgEl.offsetWidth; msgEl.classList.add('is-pop');
    }

    function count(to) {
      if (reduced) { shown = to; totalEl.textContent = to; return; }
      var from = shown, t0 = performance.now();
      (function step(t) {
        var k = Math.min(1, (t - t0) / 600);
        shown = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3)));
        totalEl.textContent = shown;
        if (k < 1) requestAnimationFrame(step);
      })(t0);
    }

    function update(quiet) {
      var t = total();
      count(t);
      rig.style.setProperty('--bend', (Math.min(t - BAR_KG, 280) / 280 * 5).toFixed(2) + 'deg');
      if (!quiet) {
        var m = '';
        msgs.forEach(function (x) { if (t >= x[0]) m = x[1]; });
        say(m || hint);
      }
      if (cta) {
        var on = t >= 100;
        cta.classList.toggle('is-on', on);
        cta.tabIndex = on ? 0 : -1;
      }
    }

    function fits(kg) {
      if (loaded.length >= max) return false;
      var box = sides[0];
      var used = 0;
      box.querySelectorAll('.pc-bb__plate:not(.is-out)').forEach(function (p) { used += p.offsetWidth + 2; });
      var s = parseFloat(getComputedStyle(el).getPropertyValue('--s')) || 1;
      return used + PLATES[kg].w * s <= box.clientWidth;
    }

    function add(kg, quiet, chip) {
      if (!PLATES[kg]) return;
      if (!fits(kg)) {
        say(el.dataset.full);
        if (chip) { chip.classList.remove('is-no'); void chip.offsetWidth; chip.classList.add('is-no'); }
        return;
      }
      loaded.push(kg);
      sides.forEach(function (side) {
        var p = document.createElement('i');
        p.className = 'pc-bb__plate';
        p.style.setProperty('--w', PLATES[kg].w);
        p.style.setProperty('--h', PLATES[kg].h);
        p.style.setProperty('--c', PLATES[kg].c);
        side.appendChild(p);
      });
      stage.classList.remove('is-thud'); void stage.offsetWidth; stage.classList.add('is-thud');
      update(quiet);
    }

    function reset() {
      loaded = [];
      el.querySelectorAll('.pc-bb__plate').forEach(function (p) {
        p.classList.add('is-out');
        setTimeout(function () { p.remove(); }, reduced ? 0 : 350);
      });
      update(true);
      say(hint);
    }

    el.querySelectorAll('[data-bb-add]').forEach(function (b) {
      b.addEventListener('click', function () { add(b.dataset.bbAdd, false, b); });
    });
    el.querySelector('[data-bb-reset]').addEventListener('click', reset);
    stage.addEventListener('click', function () { add('20', false); });

    if (!reduced && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        rig.style.setProperty('--ry', (x * 26).toFixed(1) + 'deg');
        rig.style.setProperty('--rx', (-y * 16).toFixed(1) + 'deg');
      });
      el.addEventListener('pointerleave', function () {
        rig.style.setProperty('--ry', '0deg');
        rig.style.setProperty('--rx', '0deg');
      });
    }

    // Carico iniziale: mostra subito che il bilanciere si può caricare.
    setTimeout(function () { add('20', true); }, reduced ? 0 : 700);
    setTimeout(function () { add('10', true); }, reduced ? 0 : 1100);
  }

  function init(root) {
    if (!root || root.dataset.pcInit) return;
    root.dataset.pcInit = '1';
    reveal(root);
    var type = root.dataset.pcSection;
    if (type === 'hero') { heroParallax(root); barbell(root); }
    if (type === 'products') { tabs(root); rails(root); }
    if (type === 'cats') cats(root);
    if (type === 'manifesto') manifesto(root);
  }

  function initAll() { document.querySelectorAll('[data-pc-section]').forEach(init); }

  window.PCHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pc-section]').forEach(init);
  });
})();
